import { useParams } from "react-router-dom";
import CampaignScreens from "../../../CampaignScreens";
import { PageTitle } from "src/app/components/Layout/header/HeaderTitle";
import SalesPromoDetailTabPage from './SalesPromoDetailTab.component';
import SalesPromoAddPage from "../SalesPromoAdd.page";
import SalesPromoEditPage from "../SalesPromoEdit.page";


function SalesPromoDetailPage() {
  const params = useParams<{ id: string; path: string; }>()
  const breadcrumbs = [
    {
      isActive: false,
      path: CampaignScreens.LIST_SALES_PROMO.PATH,
      title: 'Sales Promotion',
    },
    { isActive: false, path: '', title: '', isSeparator: true },
  ]

  const renderPage = () => {
    if (params.path === 'form') {
      return params.id === 'new' ? <SalesPromoAddPage /> : <SalesPromoEditPage />;
    }
    return <SalesPromoDetailTabPage />;
  };

  const getPageDescription = () => {
    if (params.path === "form") {
      return params.id === "new" ? "Add" : "Edit";
    }
    return "Detail";
  };

  return (
    <>
      <PageTitle
        description={getPageDescription()}
        breadcrumbs={breadcrumbs}
      >
        SalesPromo
      </PageTitle>
      {renderPage()}
    </>
  );
}

export default SalesPromoDetailPage;
